import dayjs from 'dayjs';

const dataSimples = /^(\d{4})-(\d{2})-(\d{2})$/;
const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:Z|(\+|-)([\d|:]*))?$/;

/**
 * Custom date parcer
 * https://weblog.west-wind.com/posts/2014/jan/06/javascript-json-date-parsing-and-real-dates
 */
export class DateParser {
  static parse(key: any, value: any) {
    if (typeof value === 'string') {
      if (reISO.exec(value)) {
        return dayjs(value);
      }
      if (dataSimples.exec(value)) {
        // Usa local time: Hora, minuto, segundo e milissegundos zerados, 
        // mas GMT correpondente ao do celular
        return dayjs(value);
      }
    }

    return value;
  }
}